// extracted by mini-css-extract-plugin
export default {"symptomscirclescreen":"SymptomsCircleScreen_symptomscirclescreen__rgW6v","symptomscirclescreen-choices":"SymptomsCircleScreen_symptomscirclescreen-choices__WlNfI"};